/**
 * @typedef {Object} CatalogueCourseTeacherModel
 * @property {string} fullName
 * @property {number} personId
 * @property {string} personPictureUrl
 * @property {boolean} isContactPersonInCatalogue
 *
 * @typedef {Object} AntiForgery
 * @property {string} antiForgeryHeaderName
 * @property {string} antiForgeryHeaderValue
 *
 * @typedef {Object} SiteList
 * @property Site[] EntityArray
 *
 * @typedef {Object} Site
 * @property {number} CustomerId
 * @property {string} Title
 */

import { post } from '@itslearning/atlas/network/fetch';

export const measureKpi = (measurementId, antiForgery) => post(`/restapi/course/catalogue/external/measureKpi/v1`, measurementId, {
    headers: {
        [antiForgery.antiForgeryHeaderName]: antiForgery.antiForgeryHeaderValue
    }
});
